import { createFileRoute, redirect } from '@tanstack/react-router';
import StaffPortal from '../components/portals/StaffPortal';

export const Route = createFileRoute('/staff/reservations/new')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/staff/orders/new', search });
  },
  component: StaffLegacyNewReservationRoute,
});

function StaffLegacyNewReservationRoute() {
  return (
    <StaffPortal>
      <div />
    </StaffPortal>
  );
}
